// Indian number formatting + INR currency + DD-MM-YYYY dates.

/** Format number in Indian lakhs/crores system. 1,23,456 not 123,456. */
export function fmtIN(n, opts = {}) {
    if (n == null || isNaN(n)) return "—";
    const { decimals = 2, sign = false } = opts;
    const isNeg = n < 0;
    const abs = Math.abs(n);
    const fixed = abs.toFixed(decimals);
    const [whole, frac] = fixed.split(".");
    // Indian grouping: last 3 digits separated, then groups of 2
    let formatted;
    if (whole.length <= 3) {
        formatted = whole;
    } else {
        const last3 = whole.slice(-3);
        const rest = whole.slice(0, -3);
        const restFormatted = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
        formatted = `${restFormatted},${last3}`;
    }
    if (frac && parseFloat("0." + frac) > 0) formatted = `${formatted}.${frac}`;
    if (decimals > 0 && !frac) formatted = `${formatted}.${"0".repeat(decimals)}`;
    if (isNeg) return `(${formatted})`; // parentheses for negatives
    return sign ? `+${formatted}` : formatted;
}

/** ₹1,23,456.78 with Indian numbering. */
export function fmtINR(n, decimals = 2) {
    if (n == null || isNaN(n)) return "—";
    return `₹${fmtIN(n, { decimals })}`;
}

/** Percentage with 1 decimal place. */
export function fmtPct(n, decimals = 1) {
    if (n == null || isNaN(n)) return "—";
    return `${fmtIN(n, { decimals })}%`;
}

/** Weight in kg with 3 decimal places. */
export function fmtKg(n) {
    if (n == null || isNaN(n)) return "—";
    return `${fmtIN(n, { decimals: 3 })} kg`;
}

/** DD-MM-YYYY */
export function fmtDate(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "—";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
}

/** DD-MM-YYYY · HH:MM */
export function fmtDateTime(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "—";
    const hh = String(d.getHours()).padStart(2, "0");
    const mn = String(d.getMinutes()).padStart(2, "0");
    return `${fmtDate(iso)} · ${hh}:${mn}`;
}

/** Relative time, e.g. "2 hrs ago". */
export function fmtRelative(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)} days ago`;
    return fmtDate(iso);
}
